/*
 * Copyright © 2018, Rezo Zero
 *
 * @file BubbleScene.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import BubbleManager from '../bubbles/BubbleManager'
import { $body, $window } from '../utils/environment'
import { TweenLite } from 'gsap'

export default class BubbleScene {
    constructor (p5) {
        this.p5 = p5
        this.canvas = null
        this.bubbleManager = null
        this.managers = []
        this.margins = 50
        this.offset = this.margins * 2
        this.originalBackgroundColor = 255
        this.currentBackgroundColor = this.originalBackgroundColor

        // Binded methods
        this.onBackgroundWhite = this.onBackgroundWhite.bind(this)
        this.onBackgroundBlack = this.onBackgroundBlack.bind(this)
        this.onResize = this.onResize.bind(this)
        this.onHomepageListInit = this.onHomepageListInit.bind(this)
        this.onBubbleRandomSplit = this.onBubbleRandomSplit.bind(this)
        this.onBubbleRandom = this.onBubbleRandom.bind(this)
        this.onBubbleCenter = this.onBubbleCenter.bind(this)
        this.onBubbleColorWhite = this.onBubbleColorWhite.bind(this)
        this.onBubbleColorInitial = this.onBubbleColorInitial.bind(this)
        this.onBubbleReduceOpacity = this.onBubbleReduceOpacity.bind(this)
        this.onBubbleResetOpacity = this.onBubbleResetOpacity.bind(this)

        this.init()
    }

    init () {
        // Init manager
        this.bubbleManager = new BubbleManager()
        this.managers.push(this.bubbleManager)

        // Init events
        $window.on('background.white', this.onBackgroundWhite)
        $window.on('background.black', this.onBackgroundBlack)
        $window.on('homepage.listing', this.onHomepageListInit)
        $window.on('resize', this.onResize)
        $window.on('bubble.center', this.onBubbleCenter)
        $window.on('bubble.randomSplit', this.onBubbleRandomSplit)
        $window.on('bubble.random', this.onBubbleRandom)
        $window.on('bubble.colorWhite', this.onBubbleColorWhite)
        $window.on('bubble.colorInitial', this.onBubbleColorInitial)
        $window.on('bubble.reduceOpacity', this.onBubbleReduceOpacity)
        $window.on('bubble.resetOpacity', this.onBubbleResetOpacity)
    }

    preload () {
        console.log('BubbleScene - preload')

        for (const manager of this.managers) {
            manager.preload(this.p5)
        }
    }

    setup () {
        console.log('BubbleScene - setup')
        this.p5._pixelDensity = 1
        this.canvas = this.p5.createCanvas(window.innerWidth + this.offset, window.innerHeight + this.offset)
        this.canvas.id('bubbles-background')

        for (const manager of this.managers) {
            manager.setup(this.p5)
        }
    }

    draw () {
        this.p5.background(this.currentBackgroundColor)
        for (const manager of this.managers) {
            manager.draw(this.p5)
        }
        this.p5.rectMode('center')
    }

    onBubbleColorWhite () {
        this.bubbleManager.colorWhite(this.p5)
    }

    onBubbleColorInitial () {
        this.bubbleManager.colorInitial(this.p5)
    }

    onBubbleCenter () {
        this.bubbleManager.centerPositions(this.p5)
    }

    onBubbleRandomSplit () {
        this.bubbleManager.randomSplitPositions(this.p5)
    }

    onBubbleRandom () {
        this.bubbleManager.randomPositions(this.p5)
    }

    onBubbleReduceOpacity () {
        this.bubbleManager.reduceOpacity(this.p5)
    }

    onBubbleResetOpacity () {
        this.bubbleManager.resetOpacity(this.p5)
    }

    onBackgroundWhite () {
        this.changeBackgroundColor(255, 1)
        $body.removeClass('is-black')
    }

    onBackgroundBlack () {
        this.changeBackgroundColor(0, 1)
        $body.addClass('is-black')
    }

    onHomepageListInit () {
        this.changeBackgroundColor(0)
        this.bubbleManager.reduceOpacity(this.p5)
    }

    changeBackgroundColor (color = 255, duration = 0) {
        TweenLite.to(this, duration, {
            currentBackgroundColor: color
        })
    }

    onResize () {
        this.canvas = this.p5.createCanvas(window.innerWidth + this.offset, window.innerHeight + this.offset)
    }
}



// WEBPACK FOOTER //
// ./webpack/js/scenes/BubbleScene.js